import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import quotes from '../../assets/images/quotes.svg';

const StyledPanel = styled.div`
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 400px;
	padding: 29px;
	background-color: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
`;

const StyledQuotes = styled.div`
	position: absolute;
	top: 58px;
	left: 156px;
	width: 86px;
	height: 62px;
	background-image: url(${quotes});
	background-repeat: no-repeat;
	background-size: contain;
	pointer-events: none;
`;

const StyledTitle = styled(Text)`
	position: relative;
	margin-top: -4px;
	font-size: 20px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.5);
`;

const StyledDescription = styled(Text)`
	position: relative;
	margin-top: 22px;
	font-size: 16px;
	font-weight: 400;
	text-align: center;
	color: rgba(255, 255, 255, 0.25);
`;

export { StyledDescription, StyledPanel, StyledQuotes, StyledTitle };
